import { render, staticRenderFns } from "./list.vue?vue&type=template&id=374b05dd&scoped=true&"
import script from "./list.vue?vue&type=script&lang=ts&setup=true&"
export * from "./list.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./list.vue?vue&type=style&index=0&lang=less&"
import style1 from "./list.vue?vue&type=style&index=1&id=374b05dd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b05dd",
  null
  
)

export default component.exports